import React from 'react';
import {
  ROLES_ASEGURADO,
  ROLES_ASEGURADO_CREDITO,
  ROLES_ASEGURADO_GARANTIA,
  ROLES_CORREDOR_CREDITO,
  ROLES_CORREDOR_GARANTIA,
} from '../CONST';
import CreditPolicyDeudorLineasContainer from '../components/asegurado/credit/line/CreditPolicyDeudorLineasContainer';
import GarantiaPolicyListContainer from '../components/asegurado/garantia/GarantiaPolicyListContainer';
import CorredorCreditoPolicyListContainer from '../components/corredor/credito/CorredorCreditoPolicyListContainer';
// import CorredorGarantiaPolicyListContainer from '../components/corredor/garantia/CorredorGarantiaPolicyListContainer';
import HomePage from '../components/HomePage';
import { externalUserHasRole, userHasRole } from './helpers';
import ResumenContainer from '../components/orsan/ResumenContainer';

const getUserHome = user => {
  if (externalUserHasRole(user, ROLES_ASEGURADO_CREDITO)) {
    return { path: '/asegurado/lineas-credito', component: CreditPolicyDeudorLineasContainer };
  }
  if (userHasRole(user, ROLES_ASEGURADO)) {
    return { path: '/resumen', component: (props) => <ResumenContainer {...props} user={user} /> };
  }
  if (userHasRole(user, ROLES_ASEGURADO_GARANTIA)) {
    return { path: '/asegurado/polizas-garantia', component: GarantiaPolicyListContainer };
  }
  if (userHasRole(user, ROLES_CORREDOR_CREDITO)) {
    return { path: '/corredor/polizas-credito', component: CorredorCreditoPolicyListContainer  };
    // return { path: '/asegurado/lineas-credito', component: CreditPolicyDeudorLineasContainer };
  }
  if (userHasRole(user, ROLES_CORREDOR_GARANTIA)) {
    // return { path: '/corredor/polizas-garantia', component: CorredorGarantiaPolicyListContainer };
    return { path: '/asegurado/polizas-garantia', component: GarantiaPolicyListContainer };
  }
  return { path: '/', component: HomePage };
};

export default getUserHome;
